// TD Sequential indicator types

export type SetupDirection = 'buy' | 'sell' | 'none';

export type SignalType =
  | null
  | 'buy_9'
  | 'buy_9_perfected'
  | 'sell_9'
  | 'sell_9_perfected'
  | 'buy_13'
  | 'buy_13_qualified'
  | 'sell_13'
  | 'sell_13_qualified';

// TD Sequential data nested within OHLC bar
export interface TDSequentialData {
  id: number;
  symbol: string;
  market_date: string;
  setup_count: number;
  setup_direction: SetupDirection;
  setup_complete: boolean;
  setup_perfected: boolean;
  tdst_resistance: number | null;
  tdst_support: number | null;
  countdown_count: number;
  countdown_active: boolean;
  countdown_complete: boolean;
  countdown_qualified: boolean;
  signal_type: SignalType;
  created_at: string;
  updated_at: string;
}

// OHLC bar with optional TD Sequential data
export interface OHLCBar {
  timestamp: string;
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
  td_sequential?: TDSequentialData;
}

// Response from /api/market-data/ohlc-daily/{ticker}/
export interface OHLCResponse {
  data: {
    ticker: string;
    start_date: string;
    end_date: string;
    count: number;
    include_td: boolean;
    ohlc: OHLCBar[];
  };
}

// Chart settings
export interface TDSequentialSettings {
  showSetupCounts: boolean;
  showCountdownCounts: boolean;
  showTDSTSupport: boolean;
  showTDSTResistance: boolean;
  showPerfectedHighlights: boolean;
  showQualifiedHighlights: boolean;
}

export const DEFAULT_TD_SETTINGS: TDSequentialSettings = {
  showSetupCounts: true,
  showCountdownCounts: true,
  showTDSTSupport: true,
  showTDSTResistance: true,
  showPerfectedHighlights: true,
  showQualifiedHighlights: true,
};
